var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.947061 1.14722C0.701005 1.39335 0.562778 1.72713 0.562778 2.07516C0.562778 2.42319 0.701005 2.75697 0.94706 3.0031L7.44394 9.49997L0.94706 15.9968C0.707978 16.2444 0.575685 16.5759 0.578676 16.9201C0.581665 17.2642 0.7197 17.5934 0.963048 17.8367C1.2064 18.0801 1.53559 18.2181 1.87972 18.2211C2.22385 18.2241 2.55539 18.0918 2.80293 17.8527L10.2277 10.4279C10.4738 10.1818 10.612 9.848 10.612 9.49997C10.612 9.15194 10.4738 8.81816 10.2277 8.57204L2.80294 1.14722C2.5568 0.901166 2.22303 0.762939 1.875 0.762939C1.52697 0.762939 1.19319 0.901166 0.947061 1.14722Z",
    fill: "#4987FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonRightArrow);
export default __webpack_public_path__ + "static/media/buttonRightArrow.3575f77581d904e34ce288172523a66d.svg";
export { ForwardRef as ReactComponent };